

<div class="card mb-2" style="border: 1px solid #ffcccc; box-shadow: 0 0.125rem 0.25rem rgba(220, 53, 69, 0.15);">
  <div class="card-header" style="background: linear-gradient(135deg, #dc3545 0%, #c82333 100%); padding: 10px 15px;">
    <h6 class="mb-0" style="color: white; font-weight: 600;">
      <i class="fas fa-filter mr-2"></i>Lọc thông tin
    </h6>
  </div>
  <div class="card-body" style="padding: 15px;">
    <div class="row align-items-center">
      <div class="col-md-8">
        <div style="display: flex; align-items: center; gap: 10px;">
          <label class="control-label" style="font-weight: 500; color: #495057; margin-bottom: 0; white-space: nowrap;">
            <i class="fas fa-school mr-1" style="color: #dc3545;"></i>Lớp học:
          </label>
          <ng-select #slLop
                     class="twcollong"
                     style="flex: 1;"
                     [tabIndex]="3"
                     [openOnEnter]="false"
                     [items]="dslops"
                     bindValue="Id"
                     bindLabel="Ten"
                     tabindex="26"
                     notFoundText="Không có dữ liệu"
                     placeholder="Chọn lớp học..."
                     [searchFn]="comboSearchFn2"
                     (change)="changeLopTimKiem($event)"
                     [(ngModel)]="TimKiems.LopId">
            <ng-template ng-option-tmp let-item="item">
              <div class="rTableRow">
                <div class="rTableCell_1">{{item.Ten}}</div>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="col-md-4">
        <div class="checkbox c-checkbox" style="margin-bottom: 0;">
          <label style="color: #dc3545; font-weight: 500; cursor: pointer;">
            <input tabIndex="5" type="checkbox" [(ngModel)]="chuaphanlop" (change)="checkboxChange($event)" />
            <span class="fa fa-check"></span>
            <i class="fas fa-users-slash mr-1"></i>Chưa phân lớp
          </label>
        </div>
      </div>


    </div>
  </div>
</div>

<!-- lưới chi tiết -->
<div class="row" style="margin-left: -10px;margin-top: 2px;overflow:auto">
  <div style="padding: 0px 0px 5px 0px;color:black !important; height: calc(100vh - 240px);width:100%">
    <table id="fixTable5" class="table table-striped table-bordered table-hover table-condensed">
      <thead>
        <!--<thead>-->
        <tr>
          <th style="width:40px;text-align:center;background-color:#f3f8fc">STT</th>
          <th style="width:50px;text-align:center;background-color:#f3f8fc">{{'Chọn' | translate}}</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Trạng thái</th>
          <th *ngIf="CauHinhHienThis['Tài khoản']===true" style="min-width:150px;text-align:center;background-color:#f3f8fc">Tài khoản</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên học sinh</th>
          <th *ngIf="CauHinhHienThis['Bí danh']===true" style="min-width:120px;text-align:center;background-color:#f3f8fc">Bí danh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên phụ huynh</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Số điện thoại</th>
          <th style="min-width:120px;text-align:center;background-color:#f3f8fc">Tên lớp</th>
          <th *ngIf="CauHinhHienThis['Phụ trách']===true" style="min-width:120px;text-align:left;background-color:#f3f8fc">Phụ trách</th>


        </tr>

        <tr class="filter-row">
          <td style="text-align:center"></td>
          <td style="text-align:center">
            <input type="checkbox" [(ngModel)]="TatCa" (click)="TichTatCa()" />
          </td>
          <td style="text-align:center">
            <ng-select #slTrangThai
                       class="twcollong"
                       [tabIndex]="3"
                       [openOnEnter]="false"
                       [items]="dstrangthais"
                       bindValue="Id"
                       bindLabel="Ten"
                       notFoundText="Không có dữ liệu"
                       [searchFn]="comboSearchFn2"
                       (change)="changeTrangThai($event)"
                       [(ngModel)]="TimKiems.TrangThai">
              <ng-template ng-option-tmp let-item="item">
                <div class="rTableRow">
                  <div class="rTableCell">{{item.Ten}}</div>
                </div>
              </ng-template>
            </ng-select>
          </td>

          <td *ngIf="CauHinhHienThis['Tài khoản']===true">
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TaiKhoan" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.HoTen" placeholder="Gõ ký tự và ấn enter" (keydown)=onKeydownEvent($event)>
          </td>
          <td *ngIf="CauHinhHienThis['Bí danh']===true">
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.BiDanh" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.TenPhuHuynh" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td>
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.SoDienThoai" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>
          <td style="text-align:center"></td>
          <td *ngIf="CauHinhHienThis['Phụ trách']===true">
            <input class="form-control" style="width:100%;font-style:italic;font-size:11px;height:25px !important" type="text"
                   [(ngModel)]="TimKiems.PhuTrach" placeholder="Tìm kiếm" (keydown)=onKeydownEvent($event)>
          </td>

        </tr>

      </thead>
      <tbody style="max-height:calc(100vh - 300px);">
        <tr *ngFor="let u of datas">
          <td style="width:40px;text-align:center"><a>{{u.STT}}</a></td>
          <td style="text-align:center;width:50px"><input type="checkbox" [(ngModel)]="u.Tich" /></td>
          <td style="min-width:120px">
            <!--<a>{{u.TrangThai}}</a>-->
            <div class="x-grid-cell-inner" style="text-align: center;">
              <a *ngIf="u.TT==1" style="background-color: #00a651!important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==2" style="background-color: orange !important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>
              <a *ngIf="u.TT==0" style="background-color: red !important;border-radius: 5px;font-size: 12px;padding: 2px 8px;color: #FFFFFF;">
                {{u.TrangThai}}
              </a>

            </div>
          </td>
          <td *ngIf="CauHinhHienThis['Tài khoản']===true" style="min-width:150px"><a>{{u.UserName}}</a></td>
          <td style="min-width:120px"><a>{{u.HoVaTen}}</a></td>
          <td *ngIf="CauHinhHienThis['Bí danh']===true" style="min-width:120px"><a>{{u.TenGoiKhac}}</a></td>
          <td style="min-width:120px"><a>{{u.TenPhuHuynh}}</a></td>
          <td style="min-width:120px"><a>{{u.DienThoaiDiDong}}</a></td>
          <td style="min-width:120px"><a>{{u.TenLop}}</a></td>
          <td *ngIf="CauHinhHienThis['Phụ trách']===true" style="min-width:120px">{{u.PhuTrach}}</td>

        </tr>
      </tbody>
    </table>


  </div>

</div>


<div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
  <div style="display: flex;">
    <div *ngIf="totalItems>=10">
      <ul class="pagination">
        <li [ngClass]="{disabled: currentPage === 1}">
          <a (click)="setPage(1)"><<</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(currentPage + 1)">></a>
        </li>
        <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
          <a (click)="setPage(page.Id)">{{page.Id}}</a>
        </li>
        <li [ngClass]="{disabled:currentPage === 1}">
          <a (click)="setPage(currentPage - 1)"><</a>
        </li>
        <li [ngClass]="{disabled:currentPage === totalPages}">
          <a (click)="setPage(totalPages)">>></a>
        </li>
        <li>
          <input type="number" style="width:50px;height:25px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
        </li>
        <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
      </ul>
    </div>
    <div style=" display: flex; justify-items: center; align-items: center; margin-left: 5px; color: red;">
      Phân học sinh vào lớp:
      <ng-select #slLop
                 class="twcollong"
                 [tabIndex]="3"
                 [openOnEnter]="false"
                 [items]="dslops"
                 bindValue="Id"
                 bindLabel="Ten"
                 tabindex="26"
                 notFoundText="Không có dữ liệu"               
                 [searchFn]="comboSearchFn2"               
                 [(ngModel)]="lopid">
        <ng-template ng-option-tmp let-item="item">
          <div class="rTableRow">
            <div class="rTableCell_1">{{item.Ten}}</div>
          </div>
        </ng-template>
      </ng-select>
    </div>
    
  </div>
  
  <div class="">
    <button type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">{{'Lưu lại' | translate}}</button>
    <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
  </div>

</div>








